"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __jsx = React.createElement;
function SvgComponent(props) {
  return __jsx("svg", (0, _extends2.default)({
    width: 24,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), __jsx("g", {
    fill: "none",
    fillRule: "evenodd"
  }, __jsx("path", {
    d: "M-1424-1246H496v4595h-1920z"
  }), __jsx("path", {
    d: "M7.548 19.974c9.057 0 14.01-7.674 14.01-14.328 0-.218-.005-.435-.014-.651A10.138 10.138 0 0024 2.387a9.65 9.65 0 01-2.828.793A5.036 5.036 0 0023.338.394a9.744 9.744 0 01-3.127 1.223A4.868 4.868 0 0016.617.026c-2.72 0-4.925 2.255-4.925 5.035 0 .395.044.78.128 1.148C7.728 6 4.1 3.995 1.67.948a5.11 5.11 0 00-.667 2.53c0 1.748.87 3.29 2.191 4.193a4.806 4.806 0 01-2.23-.63v.064c0 2.44 1.697 4.475 3.95 4.937a4.83 4.83 0 01-1.298.177 4.795 4.795 0 01-.926-.09c.627 2 2.445 3.456 4.6 3.497A9.74 9.74 0 010 17.712a13.714 13.714 0 007.548 2.262",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}
var _default = exports.default = SvgComponent;